// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".white-board[data-v-63b73c22] {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
